var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "action-pane-wrapper h-100",
      attrs: { id: "follow-up-tab" },
    },
    [
      _c(
        "form",
        {
          staticClass: "h-100",
          attrs: { id: _vm.formId + "-form", autocomplete: "off" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "form-group-material mb-0 form-group-wide no-validation-icons",
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.description,
                    expression: "description",
                  },
                ],
                ref: "descriptionField",
                staticClass: "form-control required",
                attrs: {
                  id: "description-text",
                  placeholder: _vm.$t("global.actions.enterDescription"),
                  type: "text",
                  name: "description",
                },
                domProps: { value: _vm.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.description = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.characterCount > 3500
                ? _c(
                    "div",
                    {
                      staticClass: "character-counter",
                      class: { "text-danger": _vm.isMaxLengthReached },
                    },
                    [
                      _vm.isMaxLengthReached
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "client-profile.actions.reduceDescriptionSize"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n        (" +
                          _vm._s(_vm.characterCount) +
                          "/" +
                          _vm._s(_vm.maxCharacterCount) +
                          ")\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "description-text" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.actions.enterDescription"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "d-none",
                  attrs: { for: "enter-description-id" },
                },
                [_vm._v(_vm._s(_vm.$t("global.actions.enterDescription")))]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "foreColorPicker" } },
                [_vm._v("Color Picker")]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "backColorPicker" } },
                [_vm._v("Color Picker")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row align-items-center justify-content-between mt-3",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-4 col-xl-3",
                  staticStyle: { display: "table" },
                },
                [
                  _c("span", { staticClass: "bold tiny text-uppercase mr-3" }, [
                    _vm._v(_vm._s(_vm.$t("global.words.assign"))),
                  ]),
                  _vm._v(" "),
                  _c("assignee-select", {
                    ref: "assigneeSelect",
                    staticClass: "w-100",
                    attrs: {
                      id: "follow-up-tab-assignees",
                      label: "assignee select",
                      "client-profile-id": _vm.clientProfileId,
                      assignees: _vm.assignees,
                      "inline-edit": false,
                      owner: _vm.owner,
                      "hidden-label": "",
                    },
                    on: { change: _vm.handleNotifyChange },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 col-lg-4 col-xl-3 mt-3 mt-md-0" },
                [
                  _c("span", { staticClass: "bold tiny text-uppercase mr-3" }, [
                    _vm._v(_vm._s(_vm.$t("global.words.when")) + "?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "field",
                    { staticClass: "mb-0", attrs: { name: "scheduledDate" } },
                    [
                      _c("date-section", {
                        attrs: {
                          value: _vm.scheduledDate,
                          name: "scheduledDate",
                          placeholder: "YYYY-MM-DD",
                          "class-name": "required valid-date future-date",
                        },
                        on: { change: _vm.handleScheduledDateChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 col-lg-4 col-xl-3 mt-3 mt-lg-0" },
                [
                  _c("span", { staticClass: "bold tiny text-uppercase mr-3" }, [
                    _vm._v(_vm._s(_vm.$t("global.words.at"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-container form-group-material form-group-material-no-label position-relative fe-dp",
                    },
                    [
                      _c("time-input", {
                        attrs: {
                          id: "scheduled-time",
                          "default-value": _vm.followUpNotificationTime,
                        },
                        model: {
                          value: _vm.scheduledTime,
                          callback: function ($$v) {
                            _vm.scheduledTime = $$v
                          },
                          expression: "scheduledTime",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "d-none",
                          attrs: { for: "scheduled-time" },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.time")))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-md col-lg-auto col-xl-auto mt-md-3 mt-lg-0",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row align-items-center justify-content-end justify-content-lg-end",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-auto mt-3 mt-md-0" },
                        [
                          _c("checkbox-section", {
                            staticClass: "pretty",
                            attrs: {
                              name: "default",
                              label: _vm.$t(
                                "client-profile.actions.setAsDefault"
                              ),
                              checked: _vm.isDefaultTime,
                              "container-class":
                                "mb-0 text-capitalize text-right",
                            },
                            on: { change: _vm.handleDefaultTime },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-auto mt-3 mt-md-0" }, [
                        _c(
                          "button",
                          {
                            ref: "submitFollowUp",
                            staticClass:
                              "btn btn-primary btn-sm submit-changes simple-button",
                            class: _vm.formId,
                            attrs: { disabled: !_vm.canSave, type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.followUpId
                                    ? _vm.$t(
                                        "client-profile.actions.editActivity"
                                      )
                                    : _vm.$t(
                                        "client-profile.actions.createActivity"
                                      )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }